import React, { Suspense } from "react";
import { LayoutContainer, SpinnerContainer } from "./styles";
import { Navbar } from "../Navbar";
import { Footer } from "../Footer";
import { LoadSpinner } from "@monorepo/load-spinner";

export const Layout = ({ children }) => {
    return (
        <LayoutContainer>
            <Navbar />
            <Suspense
                fallback={
                    <SpinnerContainer>
                        <LoadSpinner />
                    </SpinnerContainer>
                }
            >
                {children}
            </Suspense>
            <Footer />
        </LayoutContainer>
    );
};
